import React, { useState, Suspense } from 'react'
import Protected from '../../Protected'
import { LoaderProvider } from '../../context/FormLoader'
import Loader from '../../common/Spinner'

const CheckDetailsStep = React.lazy(
  () => import('../enquiry-steps/CheckDetailsStep')
)
const GetHelpStep = React.lazy(() => import('../enquiry-steps/GetHelpStep'))

const EnquiryCreateWizard = () => {
  const [step, setStep] = useState(1)

  const move = (value) => {
    if (value < 1 || value > 3) {
      return
    }
    setStep(value)
  }

  const renderStep = () => {
    switch (step) {
      case 1:
        return <CheckDetailsStep onSave={move} nextStep={2} />
      case 2:
        return <GetHelpStep />
      default:
        return <CheckDetailsStep onSave={move} nextStep={2} />
    }
  }

  return (
    <Protected>
      <Suspense fallback={<Loader />}>
        <LoaderProvider>
          <React.Fragment>{renderStep()}</React.Fragment>
        </LoaderProvider>
      </Suspense>
    </Protected>
  )
}

export default EnquiryCreateWizard
